<template>
  <div class="main-menu">
    <div class="menu-srcoll">
      <vuescroll :ops="ops">
        <el-menu
          :default-active="defaultActive"
          :unique-opened="true"
          background-color="#1c2b36"
          text-color="#fff"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <template v-for="(item, index) in menuList">
            <el-submenu :index="item.name" :key="index" v-if="item.children&&item.children.length > 0">
              <template slot="title">
                <!-- <i :class="['el-icon-img', menuIcon(index)]"></i> -->
                <span>{{ item.name }}</span>
              </template>
              <template v-for="(i, indexs) in item.children">
                <el-menu-item
                  :index="i.url"
                  v-if="i.url&&i.url!='null'"
                  :key="indexs"
                  @click="goUrl(i.url)"
                >{{ i.name}}</el-menu-item>
              </template>
            </el-submenu>
            <template v-else>
              <el-menu-item :index="item.url" :key="index" v-if="item.url" @click="goUrl(item.url)">
                <!-- <i class="el-icon-menu"></i> -->
                <span slot="title">{{ item.name }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </vuescroll>
    </div>
  </div>
</template>

<script>
import vuescroll from "vuescroll";
export default {
  data() {
    return {
      menuList:[],
      // menuList: [
      //   {
      //     id: 1,
      //     parent: "0",
      //     lev: "null",
      //     name: "用户管理",
      //     img: "",
      //     children: [
      //       {
      //         id: 2,
      //         parent: "1",
      //         lev: "null",
      //         name: "用户列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/user_admin_list.html",
      //         link:'userList'
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "javascript:void(0)"
      //   },
      //   {
      //     id: 268,
      //     parent: "0",
      //     lev: "null",
      //     name: "销售合同管理",
      //     img: "",
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "html/user_market_contract.html",
      //     link:'contract'
      //   },
      //   {
      //     id: 44,
      //     parent: "0",
      //     lev: "null",
      //     name: "系统配置",
      //     img: "",
      //     children: [
      //       {
      //         id: 45,
      //         parent: "44",
      //         lev: "null",
      //         name: "短信模板列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/message_list.html",
      //         link: 'noteModule'
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: ""
      //   },
      //   {
      //     id: 46,
      //     parent: "0",
      //     lev: "null",
      //     name: "文章模块",
      //     img: "",
      //     children: [
      //       {
      //         id: 47,
      //         parent: "46",
      //         lev: "null",
      //         name: "文章分类",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/article_cate.html",
      //         link:"articleClassify"
      //       },
      //       {
      //         id: 48,
      //         parent: "46",
      //         lev: "null",
      //         name: "文章列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/article_list.html",
      //         link:"articleList"
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: ""
      //   },
      //   {
      //     id: 46,
      //     parent: "0",
      //     lev: "null",
      //     name: "商城管理",
      //     img: "",
      //     children: [
      //       {
      //         id: 47,
      //         parent: "46",
      //         lev: "null",
      //         name: "商品分类",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/article_cate.html",
      //         link:"goodsClassify"
      //       },
      //       {
      //         id: 48,
      //         parent: "46",
      //         lev: "null",
      //         name: "商品列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/article_list.html",
      //         link:"goodsList"
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: ""
      //   },
      //   {
      //     id: 238,
      //     parent: "0",
      //     lev: "null",
      //     name: "财务中心",
      //     img: "",
      //     children: [
      //           {
      //             id: 243,
      //             parent: "242",
      //             lev: "null",
      //             name: "收款记录",
      //             img: "",
      //             isDri: "null",
      //             code: "null",
      //             menu: "null",
      //             isDel: "null",
      //             url: "html/goods_pay_record_list.html",
      //             link:'recordCollect'
      //           },
      //           {
      //             id: 244,
      //             parent: "242",
      //             lev: "null",
      //             name: "待审核退款",
      //             img: "",
      //             isDri: "null",
      //             code: "null",
      //             menu: "null",
      //             isDel: "null",
      //             url: "html/goods_order_self_examine.html",
      //             link:'recordAuditRefund'
      //           },
      //           {
      //             id: 245,
      //             parent: "242",
      //             lev: "null",
      //             name: "退款记录",
      //             img: "",
      //             isDri: "null",
      //             code: "null",
      //             menu: "null",
      //             isDel: "null",
      //             url: "html/goods_order_self_examine_record.html",
      //             link:'recordRefund'
      //           }
      //         ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "javascript:;"
      //   },
      //   {
      //     id: 112,
      //     parent: "0",
      //     lev: "null",
      //     name: "订单管理",
      //     img: "",
      //     children: [
      //           {
      //             id: 192,
      //             parent: "186",
      //             lev: "null",
      //             name: "在线订单",
      //             img: "",
      //             isDri: "null",
      //             code: "null",
      //             menu: "null",
      //             isDel: "null",
      //             url: "html/goods_order_already_admin_list.html",
      //             link:"onlineOrder"
      //           },
      //           {
      //             id: 263,
      //             parent: "186",
      //             lev: "null",
      //             name: "报单订单",
      //             img: "",
      //             isDri: "null",
      //             code: "null",
      //             menu: "null",
      //             isDel: "null",
      //             url: "html/goods_order_declaration_admin_list.html",
      //             link:'billOrder'
      //           }
      //         ]
      //     ,
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "javascript:void(0)"
      //   },
      //   {
      //     id: 127,
      //     parent: "0",
      //     lev: "null",
      //     name: "用户提现管理",
      //     img: "",
      //     children: [
      //       {
      //         id: 166,
      //         parent: "127",
      //         lev: "null",
      //         name: "提现申请",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/withdrawal_admin_list.html",
      //         link:"withdrawApply"
      //       },
      //       {
      //         id: 167,
      //         parent: "127",
      //         lev: "null",
      //         name: "提现记录",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/withdrawal_admin_record.html",
      //         link:'withdrawRecord'
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "javascript:void(0)"
      //   },
      //   {
      //     id: 4556,
      //     parent: "0",
      //     lev: "null",
      //     name: "权限管理",
      //     img: "",
      //     children: [
      //       {
      //         id: 233,
      //         parent: "1",
      //         lev: "null",
      //         name: "账户列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/user_admin_list.html",
      //         link:'accountList'
      //       },
      //       {
      //         id: 233,
      //         parent: "1",
      //         lev: "null",
      //         name: "角色列表",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/user_admin_list.html",
      //         link:'roleList'
      //       },
      //       {
      //         id: 233,
      //         parent: "1",
      //         lev: "null",
      //         name: "权限分配",
      //         img: "",
      //         isDri: "null",
      //         code: "null",
      //         menu: "null",
      //         isDel: "null",
      //         url: "html/user_admin_list.html",
      //         link:'permissionAssign'
      //       }
      //     ],
      //     isDri: "null",
      //     code: "null",
      //     menu: "null",
      //     isDel: "null",
      //     url: "javascript:void(0)"
      //   }
      // ],
      ops: {
        bar: {
          background: "#ddd",
          keepShow: false,
          size: "3px",
          minSize: 0.2
        }
      },
      defaultActive: "home",
      defaultOpeneds: []
    };
  },
  components: {
    vuescroll
  },
  created() {
    this.getUserMenuFunc()
    this.routeActiveFunc(this.$route);
    this.getSubNavFunc(this.$route.name)
    // this.defaultOpeneds = this.menuList.map(x => x.name);
  },
  watch: {
    $route(val) {
      this.routeActiveFunc(val);
      this.getSubNavFunc(val.name);
    }
  },
  methods: {
    menuIcon(index) {
      let path = this.menuList[index].children[0].url;
      let icon = "";
      return icon;
    },
    handleOpen() {},
    handleClose() {},
    async getUserMenuFunc() {
      let res = await this.$http.getUserMenu();
      if (res) {
        let menu = res.data
        let menuList = [];
        for(let i = 0;i<menu.length;i++) {
          if (menu[i].children&&menu[i].children.length>0) {
            for(let j = 0;j<menu[i].children.length;j++) {
              if (menu[i].children[j].url!='null') {
                if(j==0){
                  menuList.push({name:menu[i].name,children:[menu[i].children[j]]})
                } else {
                  menuList[menuList.length-1].children.push(menu[i].children[j])
                }
              }
            }
          }else {
            if (menu[i].url!='null') {
                menuList.push(menu[i])
              }
          }
        }
        this.menuList = menuList
        if(this.$route.query.loginEnter) {
          if(this.menuList[0].children&&this.menuList[0].children.length>0) {
            this.$router.push({name:this.menuList[0].children[0].url})
          } else{
            this.$router.push({name:this.menuList[0].url})
          }
        }
      }
    },
    routeActiveFunc(val) {
      let pathSplit = val.path.split("/");
      if (pathSplit.length > 2) {
        let path = pathSplit[0] + pathSplit[1];
        this.defaultActive = path;
      } else {
        this.defaultActive = val.name;
      }
    },
    getSubNavFunc(name){
      let arr=[]
      for(let i=0;i<this.menuList.length;i++){
        if(this.menuList[i].children&&this.menuList[i].children.length>0){
          for(let j=0;j<this.menuList[i].children.length;j++) {
            if(name==this.menuList[i].children[j].url){
              arr.push({
                name:this.menuList[i].name,
                path:this.menuList[i].url||''
              })
              arr.push({
                name:this.menuList[i].children[j].name,
                path:this.menuList[i].children[j].url||''
              })
            }
          }
        }else{
          if(name&&this.menuList[i].url==name){
            arr.push({
                name:this.menuList[i].name,
                path:this.menuList[i].url
              })
            break;
          }
        }
      }
      this.$emit('func',arr)
    },
    goUrl(url) {
      if(url.indexOf('javascript:')>-1||!url){
        this.$router.push({ name: 'notFound' });
      } else {
        this.getSubNavFunc(url)
        this.$router.push({ name: url });
      }
    }
  }
};
</script>

<style>
.main-menu {
  width: 220px;
  height: 100%;
  overflow: hidden;
  background: #1c2b36;
  flex-shrink: 0;
  position: relative;
}
.el-menu{
  border-right: 1px solid #1c2b36;
}
.main-menu .menu-srcoll {
    height: calc(100% - 10px);
  }
.el-submenu.is-active.is-opened .el-menu-item.is-active,.el-menu>.el-menu-item.is-active{
  background: #209e91 !important;
  color: #fff;
}
.el-menu-item.is-active:hover{
  color: #fff !important;
}
.el-menu-item:hover{
  color: #209e91 !important;
}
.el-submenu.is-active.is-opened div,.el-submenu.is-active.is-opened li{
  background-color: #16222B !important;
}
</style>
